import { render, staticRenderFns } from "./widgetInput.vue?vue&type=template&id=601b6374&scoped=true"
import script from "./widgetInput.vue?vue&type=script&lang=js"
export * from "./widgetInput.vue?vue&type=script&lang=js"
import style0 from "./widgetInput.vue?vue&type=style&index=0&id=601b6374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b6374",
  null
  
)

export default component.exports